<template>
    <div class="g cart-list-header">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">
    .g.cart-list-header {
        
    }
</style>
